export default __webpack_public_path__ + "static/media/lupa.e0bd4430.svg";